/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as DeletionConfirmedRouteImport } from './routes/deletion-confirmed'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as PortalTokenRouteImport } from './routes/portal.$token'
import { Route as OauthCallbackRouteImport } from './routes/oauth/callback'
import { Route as IntegrationsSlugRouteImport } from './routes/integrations/$slug'
import { Route as DashboardViewTokenRouteImport } from './routes/dashboard-view.$token'
import { Route as BrandViewTokenRouteImport } from './routes/brand-view.$token'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as AuthenticatedWhatsNewRouteImport } from './routes/_authenticated/whats-new'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated/activity'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthCheckEmailRouteImport } from './routes/_auth/check-email'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedGoalsIndexRouteImport } from './routes/_authenticated/goals/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedAlertsIndexRouteImport } from './routes/_authenticated/alerts/index'
import { Route as ReportsReportIdPrintRouteImport } from './routes/reports.$reportId.print'
import { Route as AuthenticatedSettingsThemesRouteImport } from './routes/_authenticated/settings/themes'
import { Route as AuthenticatedSettingsTeamRouteImport } from './routes/_authenticated/settings/team'
import { Route as AuthenticatedSettingsTagsRouteImport } from './routes/_authenticated/settings/tags'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsBrandingRouteImport } from './routes/_authenticated/settings/branding'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings/billing'
import { Route as AuthenticatedSettingsAiAccessRouteImport } from './routes/_authenticated/settings/ai-access'
import { Route as AuthenticatedReportsGenerateRouteImport } from './routes/_authenticated/reports/generate'
import { Route as AuthenticatedReportsEditorMockupRouteImport } from './routes/_authenticated/reports/editor-mockup'
import { Route as AuthenticatedDashboardNewRouteImport } from './routes/_authenticated/dashboard/new'
import { Route as AuthenticatedClientsClientIdRouteImport } from './routes/_authenticated/clients/$clientId'
import { Route as AuthenticatedSettingsBillingSuccessRouteImport } from './routes/_authenticated/settings/billing_.success'
import { Route as AuthenticatedReportsReportIdEditRouteImport } from './routes/_authenticated/reports/$reportId.edit'
import { Route as AuthenticatedDashboardDashboardIdEditRouteImport } from './routes/_authenticated/dashboard/$dashboardId.edit'

const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const McpRoute = McpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const GlossaryRoute = GlossaryRouteImport.update({
  id: '/glossary',
  path: '/glossary',
  getParentRoute: () => rootRouteImport,
} as any)
const DeletionConfirmedRoute = DeletionConfirmedRouteImport.update({
  id: '/deletion-confirmed',
  path: '/deletion-confirmed',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalTokenRoute = PortalTokenRouteImport.update({
  id: '/portal/$token',
  path: '/portal/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthCallbackRoute = OauthCallbackRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsSlugRoute = IntegrationsSlugRouteImport.update({
  id: '/integrations/$slug',
  path: '/integrations/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardViewTokenRoute = DashboardViewTokenRouteImport.update({
  id: '/dashboard-view/$token',
  path: '/dashboard-view/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandViewTokenRoute = BrandViewTokenRouteImport.update({
  id: '/brand-view/$token',
  path: '/brand-view/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWhatsNewRoute = AuthenticatedWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCheckEmailRoute = AuthCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsIndexRoute = AuthenticatedGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAlertsIndexRoute =
  AuthenticatedAlertsIndexRouteImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const ReportsReportIdPrintRoute = ReportsReportIdPrintRouteImport.update({
  id: '/reports/$reportId/print',
  path: '/reports/$reportId/print',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsThemesRoute =
  AuthenticatedSettingsThemesRouteImport.update({
    id: '/settings/themes',
    path: '/settings/themes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsTeamRoute =
  AuthenticatedSettingsTeamRouteImport.update({
    id: '/settings/team',
    path: '/settings/team',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsTagsRoute =
  AuthenticatedSettingsTagsRouteImport.update({
    id: '/settings/tags',
    path: '/settings/tags',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/settings/security',
    path: '/settings/security',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsBrandingRoute =
  AuthenticatedSettingsBrandingRouteImport.update({
    id: '/settings/branding',
    path: '/settings/branding',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/settings/billing',
    path: '/settings/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAiAccessRoute =
  AuthenticatedSettingsAiAccessRouteImport.update({
    id: '/settings/ai-access',
    path: '/settings/ai-access',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsGenerateRoute =
  AuthenticatedReportsGenerateRouteImport.update({
    id: '/reports/generate',
    path: '/reports/generate',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsEditorMockupRoute =
  AuthenticatedReportsEditorMockupRouteImport.update({
    id: '/reports/editor-mockup',
    path: '/reports/editor-mockup',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardNewRoute =
  AuthenticatedDashboardNewRouteImport.update({
    id: '/dashboard/new',
    path: '/dashboard/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsClientIdRoute =
  AuthenticatedClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsBillingSuccessRoute =
  AuthenticatedSettingsBillingSuccessRouteImport.update({
    id: '/settings/billing_/success',
    path: '/settings/billing/success',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsReportIdEditRoute =
  AuthenticatedReportsReportIdEditRouteImport.update({
    id: '/reports/$reportId/edit',
    path: '/reports/$reportId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardDashboardIdEditRoute =
  AuthenticatedDashboardDashboardIdEditRouteImport.update({
    id: '/dashboard/$dashboardId/edit',
    path: '/dashboard/$dashboardId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/deletion-confirmed': typeof DeletionConfirmedRoute
  '/glossary': typeof GlossaryRoute
  '/mcp': typeof McpRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/waitlist': typeof WaitlistRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/whats-new': typeof AuthenticatedWhatsNewRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/brand-view/$token': typeof BrandViewTokenRoute
  '/dashboard-view/$token': typeof DashboardViewTokenRoute
  '/integrations/$slug': typeof IntegrationsSlugRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/portal/$token': typeof PortalTokenRoute
  '/blog/': typeof BlogIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/clients/$clientId': typeof AuthenticatedClientsClientIdRoute
  '/dashboard/new': typeof AuthenticatedDashboardNewRoute
  '/reports/editor-mockup': typeof AuthenticatedReportsEditorMockupRoute
  '/reports/generate': typeof AuthenticatedReportsGenerateRoute
  '/settings/ai-access': typeof AuthenticatedSettingsAiAccessRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/branding': typeof AuthenticatedSettingsBrandingRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/tags': typeof AuthenticatedSettingsTagsRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/settings/themes': typeof AuthenticatedSettingsThemesRoute
  '/reports/$reportId/print': typeof ReportsReportIdPrintRoute
  '/alerts/': typeof AuthenticatedAlertsIndexRoute
  '/clients/': typeof AuthenticatedClientsIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/goals/': typeof AuthenticatedGoalsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/dashboard/$dashboardId/edit': typeof AuthenticatedDashboardDashboardIdEditRoute
  '/reports/$reportId/edit': typeof AuthenticatedReportsReportIdEditRoute
  '/settings/billing/success': typeof AuthenticatedSettingsBillingSuccessRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/deletion-confirmed': typeof DeletionConfirmedRoute
  '/glossary': typeof GlossaryRoute
  '/mcp': typeof McpRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/waitlist': typeof WaitlistRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/activity': typeof AuthenticatedActivityRoute
  '/whats-new': typeof AuthenticatedWhatsNewRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/brand-view/$token': typeof BrandViewTokenRoute
  '/dashboard-view/$token': typeof DashboardViewTokenRoute
  '/integrations/$slug': typeof IntegrationsSlugRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/portal/$token': typeof PortalTokenRoute
  '/blog': typeof BlogIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/clients/$clientId': typeof AuthenticatedClientsClientIdRoute
  '/dashboard/new': typeof AuthenticatedDashboardNewRoute
  '/reports/editor-mockup': typeof AuthenticatedReportsEditorMockupRoute
  '/reports/generate': typeof AuthenticatedReportsGenerateRoute
  '/settings/ai-access': typeof AuthenticatedSettingsAiAccessRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/branding': typeof AuthenticatedSettingsBrandingRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/tags': typeof AuthenticatedSettingsTagsRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/settings/themes': typeof AuthenticatedSettingsThemesRoute
  '/reports/$reportId/print': typeof ReportsReportIdPrintRoute
  '/alerts': typeof AuthenticatedAlertsIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/goals': typeof AuthenticatedGoalsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/dashboard/$dashboardId/edit': typeof AuthenticatedDashboardDashboardIdEditRoute
  '/reports/$reportId/edit': typeof AuthenticatedReportsReportIdEditRoute
  '/settings/billing/success': typeof AuthenticatedSettingsBillingSuccessRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/about': typeof AboutRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/deletion-confirmed': typeof DeletionConfirmedRoute
  '/glossary': typeof GlossaryRoute
  '/mcp': typeof McpRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/waitlist': typeof WaitlistRoute
  '/_auth/check-email': typeof AuthCheckEmailRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_authenticated/activity': typeof AuthenticatedActivityRoute
  '/_authenticated/whats-new': typeof AuthenticatedWhatsNewRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/brand-view/$token': typeof BrandViewTokenRoute
  '/dashboard-view/$token': typeof DashboardViewTokenRoute
  '/integrations/$slug': typeof IntegrationsSlugRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/portal/$token': typeof PortalTokenRoute
  '/blog/': typeof BlogIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/_authenticated/clients/$clientId': typeof AuthenticatedClientsClientIdRoute
  '/_authenticated/dashboard/new': typeof AuthenticatedDashboardNewRoute
  '/_authenticated/reports/editor-mockup': typeof AuthenticatedReportsEditorMockupRoute
  '/_authenticated/reports/generate': typeof AuthenticatedReportsGenerateRoute
  '/_authenticated/settings/ai-access': typeof AuthenticatedSettingsAiAccessRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/_authenticated/settings/branding': typeof AuthenticatedSettingsBrandingRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/settings/tags': typeof AuthenticatedSettingsTagsRoute
  '/_authenticated/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/_authenticated/settings/themes': typeof AuthenticatedSettingsThemesRoute
  '/reports/$reportId/print': typeof ReportsReportIdPrintRoute
  '/_authenticated/alerts/': typeof AuthenticatedAlertsIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/goals/': typeof AuthenticatedGoalsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/dashboard/$dashboardId/edit': typeof AuthenticatedDashboardDashboardIdEditRoute
  '/_authenticated/reports/$reportId/edit': typeof AuthenticatedReportsReportIdEditRoute
  '/_authenticated/settings/billing_/success': typeof AuthenticatedSettingsBillingSuccessRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/accept-invitation'
    | '/cookie-policy'
    | '/deletion-confirmed'
    | '/glossary'
    | '/mcp'
    | '/privacy'
    | '/terms'
    | '/waitlist'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/activity'
    | '/whats-new'
    | '/blog/$slug'
    | '/brand-view/$token'
    | '/dashboard-view/$token'
    | '/integrations/$slug'
    | '/oauth/callback'
    | '/portal/$token'
    | '/blog/'
    | '/integrations/'
    | '/clients/$clientId'
    | '/dashboard/new'
    | '/reports/editor-mockup'
    | '/reports/generate'
    | '/settings/ai-access'
    | '/settings/billing'
    | '/settings/branding'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/team'
    | '/settings/themes'
    | '/reports/$reportId/print'
    | '/alerts/'
    | '/clients/'
    | '/dashboard/'
    | '/goals/'
    | '/reports/'
    | '/settings/'
    | '/tasks/'
    | '/dashboard/$dashboardId/edit'
    | '/reports/$reportId/edit'
    | '/settings/billing/success'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/accept-invitation'
    | '/cookie-policy'
    | '/deletion-confirmed'
    | '/glossary'
    | '/mcp'
    | '/privacy'
    | '/terms'
    | '/waitlist'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/activity'
    | '/whats-new'
    | '/blog/$slug'
    | '/brand-view/$token'
    | '/dashboard-view/$token'
    | '/integrations/$slug'
    | '/oauth/callback'
    | '/portal/$token'
    | '/blog'
    | '/integrations'
    | '/clients/$clientId'
    | '/dashboard/new'
    | '/reports/editor-mockup'
    | '/reports/generate'
    | '/settings/ai-access'
    | '/settings/billing'
    | '/settings/branding'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/team'
    | '/settings/themes'
    | '/reports/$reportId/print'
    | '/alerts'
    | '/clients'
    | '/dashboard'
    | '/goals'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/dashboard/$dashboardId/edit'
    | '/reports/$reportId/edit'
    | '/settings/billing/success'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/about'
    | '/accept-invitation'
    | '/cookie-policy'
    | '/deletion-confirmed'
    | '/glossary'
    | '/mcp'
    | '/privacy'
    | '/terms'
    | '/waitlist'
    | '/_auth/check-email'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/_auth/verify-email'
    | '/_authenticated/activity'
    | '/_authenticated/whats-new'
    | '/blog/$slug'
    | '/brand-view/$token'
    | '/dashboard-view/$token'
    | '/integrations/$slug'
    | '/oauth/callback'
    | '/portal/$token'
    | '/blog/'
    | '/integrations/'
    | '/_authenticated/clients/$clientId'
    | '/_authenticated/dashboard/new'
    | '/_authenticated/reports/editor-mockup'
    | '/_authenticated/reports/generate'
    | '/_authenticated/settings/ai-access'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/branding'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/security'
    | '/_authenticated/settings/tags'
    | '/_authenticated/settings/team'
    | '/_authenticated/settings/themes'
    | '/reports/$reportId/print'
    | '/_authenticated/alerts/'
    | '/_authenticated/clients/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/goals/'
    | '/_authenticated/reports/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/dashboard/$dashboardId/edit'
    | '/_authenticated/reports/$reportId/edit'
    | '/_authenticated/settings/billing_/success'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AboutRoute: typeof AboutRoute
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  CookiePolicyRoute: typeof CookiePolicyRoute
  DeletionConfirmedRoute: typeof DeletionConfirmedRoute
  GlossaryRoute: typeof GlossaryRoute
  McpRoute: typeof McpRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  WaitlistRoute: typeof WaitlistRoute
  BlogSlugRoute: typeof BlogSlugRoute
  BrandViewTokenRoute: typeof BrandViewTokenRoute
  DashboardViewTokenRoute: typeof DashboardViewTokenRoute
  IntegrationsSlugRoute: typeof IntegrationsSlugRoute
  OauthCallbackRoute: typeof OauthCallbackRoute
  PortalTokenRoute: typeof PortalTokenRoute
  BlogIndexRoute: typeof BlogIndexRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  ReportsReportIdPrintRoute: typeof ReportsReportIdPrintRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp': {
      id: '/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof McpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/glossary': {
      id: '/glossary'
      path: '/glossary'
      fullPath: '/glossary'
      preLoaderRoute: typeof GlossaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deletion-confirmed': {
      id: '/deletion-confirmed'
      path: '/deletion-confirmed'
      fullPath: '/deletion-confirmed'
      preLoaderRoute: typeof DeletionConfirmedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/$token': {
      id: '/portal/$token'
      path: '/portal/$token'
      fullPath: '/portal/$token'
      preLoaderRoute: typeof PortalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/$slug': {
      id: '/integrations/$slug'
      path: '/integrations/$slug'
      fullPath: '/integrations/$slug'
      preLoaderRoute: typeof IntegrationsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard-view/$token': {
      id: '/dashboard-view/$token'
      path: '/dashboard-view/$token'
      fullPath: '/dashboard-view/$token'
      preLoaderRoute: typeof DashboardViewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brand-view/$token': {
      id: '/brand-view/$token'
      path: '/brand-view/$token'
      fullPath: '/brand-view/$token'
      preLoaderRoute: typeof BrandViewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/whats-new': {
      id: '/_authenticated/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof AuthenticatedWhatsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/check-email': {
      id: '/_auth/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof AuthCheckEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/': {
      id: '/_authenticated/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AuthenticatedGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts/': {
      id: '/_authenticated/alerts/'
      path: '/alerts'
      fullPath: '/alerts/'
      preLoaderRoute: typeof AuthenticatedAlertsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/reports/$reportId/print': {
      id: '/reports/$reportId/print'
      path: '/reports/$reportId/print'
      fullPath: '/reports/$reportId/print'
      preLoaderRoute: typeof ReportsReportIdPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings/themes': {
      id: '/_authenticated/settings/themes'
      path: '/settings/themes'
      fullPath: '/settings/themes'
      preLoaderRoute: typeof AuthenticatedSettingsThemesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/team': {
      id: '/_authenticated/settings/team'
      path: '/settings/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/tags': {
      id: '/_authenticated/settings/tags'
      path: '/settings/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AuthenticatedSettingsTagsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/branding': {
      id: '/_authenticated/settings/branding'
      path: '/settings/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof AuthenticatedSettingsBrandingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/ai-access': {
      id: '/_authenticated/settings/ai-access'
      path: '/settings/ai-access'
      fullPath: '/settings/ai-access'
      preLoaderRoute: typeof AuthenticatedSettingsAiAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/generate': {
      id: '/_authenticated/reports/generate'
      path: '/reports/generate'
      fullPath: '/reports/generate'
      preLoaderRoute: typeof AuthenticatedReportsGenerateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/editor-mockup': {
      id: '/_authenticated/reports/editor-mockup'
      path: '/reports/editor-mockup'
      fullPath: '/reports/editor-mockup'
      preLoaderRoute: typeof AuthenticatedReportsEditorMockupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/new': {
      id: '/_authenticated/dashboard/new'
      path: '/dashboard/new'
      fullPath: '/dashboard/new'
      preLoaderRoute: typeof AuthenticatedDashboardNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/$clientId': {
      id: '/_authenticated/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthenticatedClientsClientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/billing_/success': {
      id: '/_authenticated/settings/billing_/success'
      path: '/settings/billing/success'
      fullPath: '/settings/billing/success'
      preLoaderRoute: typeof AuthenticatedSettingsBillingSuccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/$reportId/edit': {
      id: '/_authenticated/reports/$reportId/edit'
      path: '/reports/$reportId/edit'
      fullPath: '/reports/$reportId/edit'
      preLoaderRoute: typeof AuthenticatedReportsReportIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/$dashboardId/edit': {
      id: '/_authenticated/dashboard/$dashboardId/edit'
      path: '/dashboard/$dashboardId/edit'
      fullPath: '/dashboard/$dashboardId/edit'
      preLoaderRoute: typeof AuthenticatedDashboardDashboardIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCheckEmailRoute: typeof AuthCheckEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCheckEmailRoute: AuthCheckEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedActivityRoute: typeof AuthenticatedActivityRoute
  AuthenticatedWhatsNewRoute: typeof AuthenticatedWhatsNewRoute
  AuthenticatedClientsClientIdRoute: typeof AuthenticatedClientsClientIdRoute
  AuthenticatedDashboardNewRoute: typeof AuthenticatedDashboardNewRoute
  AuthenticatedReportsEditorMockupRoute: typeof AuthenticatedReportsEditorMockupRoute
  AuthenticatedReportsGenerateRoute: typeof AuthenticatedReportsGenerateRoute
  AuthenticatedSettingsAiAccessRoute: typeof AuthenticatedSettingsAiAccessRoute
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRoute
  AuthenticatedSettingsBrandingRoute: typeof AuthenticatedSettingsBrandingRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsTagsRoute: typeof AuthenticatedSettingsTagsRoute
  AuthenticatedSettingsTeamRoute: typeof AuthenticatedSettingsTeamRoute
  AuthenticatedSettingsThemesRoute: typeof AuthenticatedSettingsThemesRoute
  AuthenticatedAlertsIndexRoute: typeof AuthenticatedAlertsIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedGoalsIndexRoute: typeof AuthenticatedGoalsIndexRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedDashboardDashboardIdEditRoute: typeof AuthenticatedDashboardDashboardIdEditRoute
  AuthenticatedReportsReportIdEditRoute: typeof AuthenticatedReportsReportIdEditRoute
  AuthenticatedSettingsBillingSuccessRoute: typeof AuthenticatedSettingsBillingSuccessRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,
  AuthenticatedWhatsNewRoute: AuthenticatedWhatsNewRoute,
  AuthenticatedClientsClientIdRoute: AuthenticatedClientsClientIdRoute,
  AuthenticatedDashboardNewRoute: AuthenticatedDashboardNewRoute,
  AuthenticatedReportsEditorMockupRoute: AuthenticatedReportsEditorMockupRoute,
  AuthenticatedReportsGenerateRoute: AuthenticatedReportsGenerateRoute,
  AuthenticatedSettingsAiAccessRoute: AuthenticatedSettingsAiAccessRoute,
  AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,
  AuthenticatedSettingsBrandingRoute: AuthenticatedSettingsBrandingRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
  AuthenticatedSettingsTagsRoute: AuthenticatedSettingsTagsRoute,
  AuthenticatedSettingsTeamRoute: AuthenticatedSettingsTeamRoute,
  AuthenticatedSettingsThemesRoute: AuthenticatedSettingsThemesRoute,
  AuthenticatedAlertsIndexRoute: AuthenticatedAlertsIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedGoalsIndexRoute: AuthenticatedGoalsIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedDashboardDashboardIdEditRoute:
    AuthenticatedDashboardDashboardIdEditRoute,
  AuthenticatedReportsReportIdEditRoute: AuthenticatedReportsReportIdEditRoute,
  AuthenticatedSettingsBillingSuccessRoute:
    AuthenticatedSettingsBillingSuccessRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AboutRoute: AboutRoute,
  AcceptInvitationRoute: AcceptInvitationRoute,
  CookiePolicyRoute: CookiePolicyRoute,
  DeletionConfirmedRoute: DeletionConfirmedRoute,
  GlossaryRoute: GlossaryRoute,
  McpRoute: McpRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  WaitlistRoute: WaitlistRoute,
  BlogSlugRoute: BlogSlugRoute,
  BrandViewTokenRoute: BrandViewTokenRoute,
  DashboardViewTokenRoute: DashboardViewTokenRoute,
  IntegrationsSlugRoute: IntegrationsSlugRoute,
  OauthCallbackRoute: OauthCallbackRoute,
  PortalTokenRoute: PortalTokenRoute,
  BlogIndexRoute: BlogIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  ReportsReportIdPrintRoute: ReportsReportIdPrintRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
